(function() {
  class StockBadgeUpdater {
    constructor() {
      this.lastVariantId = null;
      this.lastState = null;
      this.lastProductUrl = null;
      this.debounceTimer = null;
      this.badgeElement = null;

      this.iconSvgs = {
        box: `<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.33333 5.20218L3.66666 2.48801M1.47333 3.92615L6 6.56711L10.5267 3.92615M6 11.8333V6.56188M10.6667 8.65372V4.47003C10.6665 4.28661 10.6185 4.10647 10.5275 3.94768C10.4365 3.78888 10.3056 3.65701 10.1481 3.56531L6.51851 1.47346C6.36086 1.38166 6.18203 1.33333 6 1.33333C5.81796 1.33333 5.63913 1.38166 5.48148 1.47346L1.85185 3.56531C1.69435 3.65701 1.56354 3.78888 1.47253 3.94768C1.38152 4.10647 1.33351 4.28661 1.33333 4.47003V8.65372C1.33351 8.83714 1.38152 9.01728 1.47253 9.17608C1.56354 9.33487 1.69435 9.46674 1.85185 9.55845L5.48148 11.6503C5.63913 11.7421 5.81796 11.7904 6 11.7904C6.18203 11.7904 6.36086 11.7421 6.51851 11.6503L10.1481 9.55845C10.3056 9.46674 10.4365 9.33487 10.5275 9.17608C10.6185 9.01728 10.6665 8.83714 10.6667 8.65372Z" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>`,
        sellingfast: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M23 18L13.5 8.5L8.5 13.5L1 6M23 18H17M23 18V12" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>`,
        clock: `<svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.583328 10.6775V7.17753M0.583328 7.17753H4.08333M0.583328 7.17753L3.28999 9.72087C4.09553 10.525 5.14059 11.0456 6.26772 11.2042C7.39486 11.3628 8.543 11.1508 9.53915 10.6001C10.5353 10.0494 11.3255 9.18989 11.7907 8.15106C12.2559 7.11223 12.3709 5.95035 12.1183 4.84049C11.8657 3.73063 11.2593 2.73292 10.3904 1.99767C9.5215 1.26243 8.43718 0.829495 7.30083 0.764092C6.16448 0.69869 5.03765 1.00437 4.09013 1.63506C3.14261 2.26576 2.42572 3.18731 2.04749 4.26087M6.99999 2.85V6L9.09999 7.05" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`
      };

      this.install();
      
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.debouncedRefresh());
      } else {
        this.debouncedRefresh();
      }
      window.addEventListener('pageshow', () => this.debouncedRefresh());
    }

    install() {
      document.addEventListener('variant:change', (e) => {
        const vid = e?.detail?.variant?.id;
        if (vid) {
          this.onVariantIdChange(vid);
        }
      });

      document.addEventListener('colorVariantChanged', (e) => {
        this.lastVariantId = null;
        this.lastState = null;
        this.lastProductUrl = window.location.pathname;
        this.badgeElement = null;
        this.debouncedRefresh(150);
      });

      document.addEventListener('change', (e) => {
        const form = e.target.closest('form[action^="/cart/add"]');
        if (form) {
          this.debouncedRefresh(150);
        }
      });

      this.observeProductChanges();
    }

    observeProductChanges() {
      const container = document.querySelector('.product__info-container');
      if (!container) return;

      const observer = new MutationObserver((mutations) => {
        let shouldRefresh = false;
        for (const mutation of mutations) {
          if (mutation.type === 'childList' && (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)) {
            shouldRefresh = true;
            break;
          }
        }
        if (shouldRefresh) {
          this.badgeElement = null;
          this.debouncedRefresh(250);
        }
      });

      observer.observe(container, {
        childList: true,
        subtree: true,
      });

      if (!this._observers) this._observers = [];
      this._observers.push(observer);
    }

    debouncedRefresh(ms = 50) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => this.refreshFromSelection(), ms);
    }

    onVariantIdChange(rawId) {
      const id = this._normalizeId(rawId);
      if (!id || id === this.lastVariantId) return;
      this.lastVariantId = id;
      this.renderBadgeIfChanged(id);
    }

    getSelectedVariantId() {
      const selectors = [
        'form[action^="/cart/add"] input[name="id"]:checked', 
        'form[action^="/cart/add"] select[name="id"]',        
        '.product-form input[name="id"]:checked',             
        '.product-form select[name="id"]',                    
        'input[name="id"]:checked',                           
        'select[name="id"]'                                   
      ];
      
      for (const selector of selectors) {
        const element = document.querySelector(selector);
        if (element) {
          if (element.type === 'radio' && element.checked) {
            return this._normalizeId(element.value);
          } else if (element.tagName === 'SELECT') {
            return this._normalizeId(element.value);
          }
        }
      }
      
      // Fallback to your original method
      const input = document.querySelector('form[action^="/cart/add"] input[name="id"], .product-form input[name="id"]');
      const id = input ? this._normalizeId(input.value) : null;
      return id;
    }

    _normalizeId(raw) {
      return raw ? String(raw).trim() : null;
    }

    refreshFromSelection() {
      const id = this.getSelectedVariantId();
      if (!id) return;
      this.lastVariantId = id;
      this.renderBadgeIfChanged(id);
    }

    getVariantData(variantId) {
      const numericId = this._normalizeId(variantId);
      if (!numericId || !window.variantStockData) return null;

      const data = window.variantStockData[numericId];
      if (!data) return null;
      
      if (data.inventory_quantity === undefined) {
        if (data.available) {
          data.inventory_quantity = 1;
          if (data.stock_state === 'no_stock') {
            data.stock_state = 'in_stock';
            data.badge_text = 'In Stock';
            data.badge_class = 'badge--in-stock';
          }
        } else {
          data.inventory_quantity = 0;
        }
      }
      
      return data;
    }

    getBadgeEl() {
      if (this.badgeElement && document.contains(this.badgeElement)) {
        return this.badgeElement;
      }
      
      this.badgeElement = document.querySelector('.product__badge');
      return this.badgeElement;
    }

    renderBadgeIfChanged(variantId) {
      const variantData = this.getVariantData(variantId);
      if (!variantData) return;

      let badgeEl = this.getBadgeEl();
      
      if (!variantData.badge_text || variantData.badge_text === '') {
        if (badgeEl) {
          badgeEl.style.display = 'none';
          badgeEl.dataset.variantId = String(variantId);
        }
        return;
      }

      if (!badgeEl) return;

      const currentVariantId = badgeEl.dataset.variantId;
      const currentState = badgeEl.dataset.stockState;
      const shouldUpdate = 
          !currentVariantId || 
          currentVariantId !== String(variantId) || 
          !currentState || 
          currentState !== variantData.stock_state;

      if (!shouldUpdate) return;

      // Update the badge
      badgeEl.style.display = '';
      badgeEl.className = 'product__badge';
      badgeEl.classList.add(variantData.badge_class);

      badgeEl.dataset.stockState = variantData.stock_state;
      badgeEl.dataset.variantId = String(variantId);

      let iconKey = 'box';
      if (variantData.stock_state === 'low_stock') iconKey = 'sellingfast';
      else if (variantData.stock_state === 'preorder') iconKey = 'clock';

      const currentSvg = badgeEl.querySelector('svg');
      if (currentSvg && this.iconSvgs[iconKey]) {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = this.iconSvgs[iconKey].trim();
        const newSvg = wrapper.firstChild;
        if (newSvg) currentSvg.replaceWith(newSvg);
      } else if (!currentSvg && this.iconSvgs[iconKey]) {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = this.iconSvgs[iconKey].trim();
        const newSvg = wrapper.firstChild;
        if (newSvg) {
          const span = badgeEl.querySelector('span');
          if (span) {
            badgeEl.insertBefore(newSvg, span);
          } else {
            badgeEl.appendChild(newSvg);
          }
        }
      }

      const span = badgeEl.querySelector('span');
      if (span) {
        span.textContent = variantData.badge_text;
      } else {
        const newSpan = document.createElement('span');
        newSpan.textContent = variantData.badge_text;
        badgeEl.appendChild(newSpan);
      }
    }

    destroy() {
      if (this._observers) {
        this._observers.forEach(obs => obs.disconnect());
      }
      clearTimeout(this.debounceTimer);
    }
  }

  if (window.stockBadgeUpdater && window.stockBadgeUpdater.destroy) {
    window.stockBadgeUpdater.destroy();
  }
  window.stockBadgeUpdater = new StockBadgeUpdater();
})();
